import React from 'react';
import '../../App.scss';
import { updateState } from "../StateHelper";
import UserAccessApi from '../../api/UserAccessApi';
import AuthorizedPage from "../../component/AuthorizedPage";
import BasicGrid from "../../component/BasicGrid";
import { Form, Button, Table, Modal, Badge } from "react-bootstrap";
import { PlusSquare } from "react-bootstrap-icons";
import CheckList from '../../component/CheckList';
import { Role } from '../../domain/Role';

const gridProps = [
  { label: "Kullanıcı Adı", attr: "userName" },
  { label: "Ad", attr: "name" },
  { label: "Soyad", attr: "surname" },
  { label: "Email", attr: "email" },
  { label: "Phone", attr: "phone" },
  { label: "Durumu", attr: "status" },
  { label: "Kayıt Tarihi", attr: "registrationDate"}
];

class UserManagement extends React.Component<any,any> {

  constructor(props: any) {
    super(props);
    this.state = {
      users: new Array(),
      filteredUsers: new Array(),
      allRoles: new Array(),
      selectedUser: new Object(),
      showUserModal: false,
      generatedPass: new Object()
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.loadUsers();
    this.loadAllRoles();
  }

  async loadUsers() {
    let response = await UserAccessApi.listAll();
    if (response.success) {
      updateState(this, "users", response.data);
      updateState(this, "filteredUsers", response.data);
    }
  }

  async loadAllRoles() {
    let response = await UserAccessApi.listAllRoles();
    if (response.success) {
      updateState(this, "allRoles", response.data);
    }
  }

  async onSubmit(e:any) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formObject = Object.fromEntries(formData);
    formObject["roles"] = this.state.checkedRoles;
    let response = await UserAccessApi.createOrUpdateUser(formObject);
    if(response.success) {
      e.target.reset();
      updateState(this ,"showUserModal", false);
      updateState(this, "selectedUser", new Object());
      this.loadUsers();
    }
}

  onModalOpen() {
    updateState(this, "showUserModal", true);
  }
  
  onModalClose() {
    updateState(this, "showUserModal", false);
    updateState(this, "selectedUser", new Object());
    this.loadUsers();
  }

  onCheckListChange(refId: any, checkedItems: any) {
    updateState(this, refId, checkedItems);
  }

  onSearch(q: string) {
    if (q && q.length <= 2) {
      return;
    }
    let matches = new Array();
    this.state.users.forEach((user: any) => {
      let userRaw = Object.values(user).join();
      if (userRaw.includes(q)) {
        matches.push(user);
      }
    });

    updateState(this, "filteredUsers", matches);
    return;
  }
  combineWithCallbacks(prob: any) {
    let userGridCallbacks = [
      {
        label: "Düzenle",
        attr: "edit",
        callback: this.onColumnEvent,
      },
      {
        label: "Şifre Üret",
        attr: "generatePass",
        callback: this.onColumnEvent,
      },
    ];
    let prp = prob;
    prp = prp.concat(userGridCallbacks);
    return prp;
  }

  async onColumnEvent(
    self: any,
    componentRef: any,
    column: any,
    selected: any
  ) {
    if(column === "edit") {
      updateState(self, "selectedUser", selected);
      updateState(self, "showUserModal", true);
    }
    if(column === "generatePass") {
      if(selected.userName == "superozisik") {
        alert("Seçilen kullanıcı için şifre üretilemez!");
        return;
      }

      let response = await UserAccessApi.generatePass(selected.id);
      if(response.success) {
        alert(selected.userName +" için yeni şifre: "+ response.data.generatedPass);
      }
    }
  }

  userCreateOrUpdateModal = () => {
    let {id, userName, name, surname, phone, email, roles} = this.state.selectedUser || new Object();
    
    let submitButton = <Button style = {{float:"right"}} variant="secondary" type="submit">Kullanıcı Tanımla</Button>;
    
    if(id) {
       submitButton = <Button style = {{float:"right"}} variant="secondary" type="submit">Kullanıcı Bilgilerini Güncelle</Button>;
    }

    return <Modal autoFocus={true} show={this.state.showUserModal} onHide={() => this.onModalClose()} dialogClassName="modal-90w">
            <Modal.Header closeButton>
              <Modal.Title>Kullanıcı Oluştur veya Güncelle</Modal.Title>
            </Modal.Header>
  
            <Modal.Body>
              <div className="centered-80-percent margin-left-right-40">
                <Form onSubmit={this.onSubmit}>
                  <Form.Group style={{display:"none"}}>
                    <Form.Control name="id" type="text" placeholder="ID" defaultValue={id || null}/>
                  </Form.Group>
                  <Form.Group className="mb-4" controlId="formUserName">
                    <Form.Label>Kullanıcı Adı</Form.Label>
                    <Form.Control name="userName" type="text" placeholder="Kullanıcı Adı" defaultValue={userName || ""}/>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formName">
                    <Form.Label>Ad</Form.Label>
                    <Form.Control name="name" type="text" placeholder="Ad" defaultValue={name || ""}/>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formSurname">
                    <Form.Label>Soyad</Form.Label>
                    <Form.Control name="surname" type="text" placeholder="Soyad" defaultValue={surname || ""}/>
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="formEmail">
                    <Form.Label>E-Mail</Form.Label>
                    <Form.Control name="email" type="text" placeholder="E-Mail" defaultValue={email || ""}/>
                  </Form.Group>
                  
                  <Form.Group className="mb-4" controlId="formSurname">
                    <Form.Label>Telefon</Form.Label>
                    <Form.Control name="phone" type="text" placeholder="Telefon" defaultValue={phone || ""}/>
                  </Form.Group>
                  
                  <Form.Label>Rolleri</Form.Label>
                  <CheckList
                    refId="checkedRoles"
                    data={this.state.allRoles}
                    checked={this.state.selectedUser.roles}
                    comparingField="key"
                    labelField="label"
                    columns={1}
                    onChange={(refId: string, checked: any) =>
                      this.onCheckListChange(refId, checked)
                    }
                  />

                  {submitButton} 
                </Form>
                </div>
            </Modal.Body>
          </Modal>
  };

  render() {
  return (
    <AuthorizedPage role={Role.BACKOFFICE_ADMIN}>
      {this.userCreateOrUpdateModal()}

      <div className="zero-div centered-95-percent">
        <div className="d-flex justify-content-between align-items-center margin-top-40">
          <h3 className="mb-0">Portal Kullanıcısı Yönetimi</h3>

          <Button
            variant="success"
            onClick={() => this.onModalOpen()}
          >
            <PlusSquare size={18} className="me-2" />
            Kullanıcı Ekle
          </Button>
        </div>

        <BasicGrid
          title="Kullanıcılar"
          componentRef="userGrid"
          that={this}
          data={this.state.filteredUsers}
          columnProps={this.combineWithCallbacks(gridProps)}
          className="margin-top-20"
        />
      </div>
    </AuthorizedPage>
  );

  }
}

export default UserManagement;
